export enum FEATURE_FLAGS {
	VIDEO_EDITING_FEATURE = "platform_video_editing_feature",
	FIBO_LITE_FEATURE = "platform_fibo_lite",
	IP_PROJECTS_FEATURE = "ip_projects_feature",
}
